
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getSerAdd, agreeSerAdd, batchAgreeSerAdd, getCustomerLimit } from '@/api/customer';
import { IPagination } from '@/types';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '../../utils';
// 1 已添加 2 未添加
const statusOptions = [
  {
    value: '2',
    label: '未添加'
  },
  {
    value: '1',
    label: '已添加'
  }
];

@Component({
  name: 'CustomerAdded'
})
export default class extends Vue {
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 1,
    total: 0
  };

  private page = 1;
  private size = 10;

  private listLoading = false;

  private formSearch = {
    customer: '',
    status: ''
  };

  private statusOptions = statusOptions;
  private tableData = [];
  private multipleSelection = [];
  private redText = '';

  created() {
    this.getSerAdd();
    this.getCustomerLimit();
  }
  handleCurrentChange(size: number) {
    this.page = size;
    this.getSerAdd();
  }

  handlePageSizeChange(size: number) {
    this.size = size;
    this.getSerAdd();
  }
  // 搜索
  private handleSearch() {
    this.getSerAdd();
  }

  // 清空
  private handleSearchClear() {
    this.formSearch = {
      customer: '',
      status: ''
    };
    this.getSerAdd();
  }

  // 获取列表
  private getSerAdd() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      customer_name: this.formSearch.customer,
      state: this.formSearch.status,
      page: this.page,
      size: this.size
    };
    getSerAdd(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.currentPage = parseInt(data.page_current);
          this.pagination.total = parseInt(data.count);
          this.tableData = data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.listLoading = false;
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.tableData = [];
        let msg = err.msg;
      });
  }

  // 获取限制红字
  private getCustomerLimit() {
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
    };
    getCustomerLimit(params)
      .then((res: any) => {
        this.redText = '当前版本限制公司客户数量' +
        res.data.customer_company_number +
        '现已添加公司客户' +
        res.data.company_num + '个。现已添加个人客户' +
        res.data.user_num + '个。';
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  // 添加为我的客户
  private agreeSerAddClick(val:any) {
    let _this = this;
    this.$confirm('确认添加吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.agreeSerAdd(val);
      })
      .catch(() => {});
  }

  private agreeSerAdd(val: any) {
    const params = {
      id: val.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_name: UserModule.getCompanyName,
      customer_user_id: val.customer_user_id,
      customer_user_name: val.customer_user_name,
      customer_company_id: val.customer_company_id,
      customer_company_name: val.customer_company_name,
      customer_type: val.customer_type
    };
    agreeSerAdd(params)
      .then((res: any) => {
        this.showSuccessMsg('添加成功');
        this.getSerAdd();
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  private batchAgreeSerAddClick() {
    if (this.multipleSelection.length <= 0) {
      this.showErrorMsg('请选择客户');
      return;
    }
    let _this = this;
    this.$confirm('确认添加吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.batchAgreeSerAdd();
      })
      .catch(() => {});
  }

  private batchAgreeSerAdd() {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_name: UserModule.getCompanyName,
      customerArr: this.multipleSelection
    };
    batchAgreeSerAdd(params)
      .then((res: any) => {
        this.showSuccessMsg('添加成功');
        this.getSerAdd();
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  private handleSelectable(row:any, index:any) {
    return parseInt(row.state) !== 1;
  }

  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
